module.exports = __webpack_public_path__ + "static/img/banner.274c9180.png";